/** @format */
import React, { FunctionComponent } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@material-ui/core';
import {
    SimCardServiceTypeAllowedParam,
    SimCardServiceTypeAllowedParamCollection,
    SimCardServiceTypeAllowedParamMap,
    SimCardServiceTypeItem,
    SimCardServiceTypeParam,
} from '../../../../interfaces/collections/SimCardServiceInterface';
import I18n from '../../../../components/Translate/I18n';
import CustomTextButtom from '../../../../components/Buttons/CustomTextButton';
import GridContainer from '../../../../components/Grid/GridContainer';
import GridItem from '../../../../components/Grid/GridItem';
import { getFeatureVerbName } from '../../../../modules/features/FeaturesTypes';
import { usePlatformResellerHeaders, usePlatformResellerList } from '../../../../modules/lib/hooks/usePlatformResellerHooks';
import { OplSimCardServiceTypeParamItemSdgFormItemView } from './OplSimCardServiceTypeParamItemSdgFormItemView';
import { preparePartnerParams } from './OplSimCardServiceTypeParamItemSdgForm';
import { OplSimCardServiceTypeParamItemSdgServicePDP5FormItemView } from './OplSimCardServiceTypeParamItemSdgServicePDP5FormItemView';

const _ = require('underscore');

type OplSimCardServiceTypeParamItemSdgViewServicePDP5Type = {
    simCardServiceType: SimCardServiceTypeItem;
    simCardServiceTypeParam: SimCardServiceTypeParam;
    simCardServiceTypeAllowedParamsCollection: SimCardServiceTypeAllowedParamCollection;
    open: boolean;
    closeCallback(): void;
};

export const OplSimCardServiceTypeParamItemSdgViewServicePDP5: FunctionComponent<OplSimCardServiceTypeParamItemSdgViewServicePDP5Type> = ({
    simCardServiceType,
    simCardServiceTypeParam,
    simCardServiceTypeAllowedParamsCollection,
    open,
    closeCallback,
}): React.ReactElement => {
    const platformResellerList = usePlatformResellerList([]);
    const platformResellerHeaders = usePlatformResellerHeaders(platformResellerList);
    const definedParam = simCardServiceTypeParam && simCardServiceTypeParam.parameters ? JSON.parse(simCardServiceTypeParam.parameters) : null;

    const getPlatformResellerName = (platformResellerId: number): string => {
        for (let i = 0; i < platformResellerHeaders.length; i++) {
            if (platformResellerId === platformResellerHeaders[i].value) {
                return platformResellerHeaders[i].name;
            }
        }
        return '';
    };

    const processParams = (
        simCardServiceTypeAllowedParam: SimCardServiceTypeAllowedParam,
        params: SimCardServiceTypeAllowedParamMap,
        oldDefinedParam: SimCardServiceTypeAllowedParamMap | null,
        paramName: string
    ): React.ReactElement => {
        return (
            <GridItem xs={6} key={'form_' + paramName + simCardServiceTypeAllowedParam.id}>
                <OplSimCardServiceTypeParamItemSdgServicePDP5FormItemView initialParam={preparePartnerParams(paramName, params, oldDefinedParam)} />
            </GridItem>
        );
    };

    const showParameters = (simCardServiceTypeAllowedParam: SimCardServiceTypeAllowedParam): Array<React.ReactElement> => {
        const result: Array<React.ReactElement> = [];
        const parameters = JSON.parse(simCardServiceTypeAllowedParam.parameters);
        _.mapObject(parameters, (val: SimCardServiceTypeAllowedParamMap, key: string): any => {
            if (_.has(definedParam, key)) {
                let d = { ...definedParam[key] };
                result.push(processParams(simCardServiceTypeAllowedParam, val, { ...definedParam[key] }, key));
            }
        });
        return result;
    };

    return (
        <Dialog open={open} maxWidth="md">
            <DialogTitle>
                <I18n trans="prov:feature.view_configuration" />
            </DialogTitle>
            <DialogContent>
                <GridContainer>
                    <GridItem xs={12}>
                        {simCardServiceTypeParam.platformResellerId && (
                            <Typography variant="body2" style={{ fontSize: '11px' }}>
                                <I18n
                                    trans="prov:feature.platform_reseller_name"
                                    valueObject={{ name: getPlatformResellerName(simCardServiceTypeParam.platformResellerId) }}
                                />
                            </Typography>
                        )}
                        {simCardServiceTypeAllowedParamsCollection['hydra:member'].map((item) => {
                            if (item.operationVerbId === simCardServiceTypeParam.verb) {
                                return (
                                    <React.Fragment key={'edit_params_' + item.id}>
                                        <hr />
                                        <GridContainer>
                                            <GridItem xs={3}>
                                                <Typography variant="subtitle2">
                                                    <I18n trans="prov:feature.operation_name" />
                                                </Typography>
                                            </GridItem>
                                            <GridItem xs={3}>
                                                <Typography variant="subtitle2">
                                                    <I18n trans={'prov:feature.' + getFeatureVerbName(item.operationVerbId)} />
                                                </Typography>
                                            </GridItem>
                                            <GridItem xs={6} />
                                            <GridItem xs={12}>
                                                <GridContainer>{showParameters(item).map((result) => result)} </GridContainer>
                                            </GridItem>
                                        </GridContainer>
                                    </React.Fragment>
                                );
                            }
                        })}
                    </GridItem>
                </GridContainer>
            </DialogContent>
            <DialogActions>
                <CustomTextButtom callback={closeCallback} callbackParam={{}} label="general:common.close" size="sm" />
            </DialogActions>
        </Dialog>
    );
};
